import { RequestState } from '../../../modules/types'

export type AccountInfo = {
  id: string
  name: string
  active: boolean
  subscriptionId: string
  subscriptionName: string
  subscriptionActive: boolean
  isDemo: boolean
}

export type SubscriptionInfo = {
  id: string
  name: string
  active: boolean
  partnerId: string
}

export type PartnerResult = {
  id: string
  count: number
}

export type SearchState = {
  includeDeactivated: boolean
  subscriptions: {
    requestState: RequestState
    timeStamp?: number
    results:  SubscriptionSearchResult[]
  },
  accounts: {
    requestState: RequestState
    timeStamp?: number
    results: AccountInfo[]
    otherPartnerResults: PartnerResult[]
  }
}

export type SubscriptionSearchResult = {
  partnerId: string,
  results: SubscriptionInfo[]
}

export const initialSearchState = {
  includeDeactivated: false,
  subscriptions: {
    requestState: RequestState.NotLoaded,
    results: []
  },
  accounts: {
    requestState: RequestState.NotLoaded,
    results: [],
    otherPartnerResults: []
  }
}
